import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import Product from "./pages/Product";
import AppNavbar from "./components/AppNavbar";
import GetAllDeals from "./utils/GetAllDeals";
import Favorite from "./components/Favorite";
import Footer from "./components/Footer";
import Dialog from "./components/Dialog";
import DismissView from "./components/DismissView";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { useDeals, useFavoriteOpen, useDialog, useCategory, useDstore, useCookie } from "./hooks";
import { categoryNames } from './constant';
import StorePage from "./pages/StorePage";
import OneSignal from 'react-onesignal';

const App = () => {
  const [deals] = useDeals();
  const [favoriteOpen] = useFavoriteOpen();
  const [dialog] = useDialog();
  const [category] = useCategory();
  const [dstore] = useDstore();
  const [cookie] = useCookie();

  const [isOpen, toggleOpen] = React.useState(true);
  React.useEffect(() => {
    OneSignal.init({ appId: '5bb82b7f-198a-4f3d-a045-3e869f43d006'});
  }, []);
  

  return (
    <BrowserRouter>
      <AppNavbar />
      <GoogleAnalytics />
      {deals.length === 0 && <GetAllDeals />}
      {favoriteOpen && <Favorite />}
      {dialog.open && <Dialog />}
      <main>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/amazon" component={() => <CategoryPage category='1' title='Amazon' />} exact />
          <Route path="/save" component={() => <CategoryPage category='23' title='省錢秘笈' />} exact />
          <Route path="/sns" component={() => <CategoryPage category='10' title='Subscribe & Save' />} exact />
          <Route path="/category" component={() => <CategoryPage category={category} title={categoryNames[category]} />} exact />
          <Route path="/category/:category" component={CategoryPage} exact />
          <Route path="/store" component={() => <StorePage dstore={dstore} />} exact />
          <Route path="/walmart" component={() => <StorePage dstore={"Walmart"} />} exact />
          <Route path="/store/:dstore" component={StorePage} exact />
          <Route path="/product" component={Product} exact />
          <Route path="/product/id/:id" component={Product} exact />
          <Route path="/product/pid/:pid" component={Product} exact />
          {/* <Route path="/backend" component={Backend} /> */}
          <Route component={Home} />
        </Switch>
      </main>
      {/* {cookie === false && <DismissView isOpen={isOpen} toggle={toggleOpen} header="Accept Cookies?" body="We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are happy with it." />} */}
      <Footer />
    </BrowserRouter>
  );
}

export default App;
